import React from 'react'
import "../styles/contact.css"
import { MdLocalPhone } from "react-icons/md";
import { IoMail } from "react-icons/io5";
import { IoLogoInstagram } from "react-icons/io5";

import { FaLocationDot } from "react-icons/fa6";

import logo from '../img/LOGObg.png'
export const Contact = () => {
    return (
        <div className='contactmain'>
            <div className='contacthead'>
                <h1>contact us</h1>
            </div>

            <div className='contactdi'>
                <br/>
                <div className='contacttxt'>
                    <p className='contacttxt1'>
                     <b><MdLocalPhone /> Phone no:</b><br/>
                     <p >&nbsp;&nbsp; +91 7871444915,<br/>&nbsp;&nbsp; +91 7904123737</p>
                     <br/>
                     <b><IoMail/> Mail:</b><br/>
                     <p>&nbsp;vpacks2017@gmail.com,<br/>&nbsp;&nbsp;innovation@vpacks.net</p>
                    </p>
                    <br />
                    <div className='contactheadadd'> <b><FaLocationDot /> Address :-</b>
                    <br />
                    <p >
                        111,jeeva street,sellur,<br />madurai,<br />TamilNadu 625002
                    </p>
                    </div>
                    <p className='follo'><b><IoLogoInstagram/> <a href="https://www.instagram.com/vpacks_2017?utm_source=qr&igsh=bG1uYnc1b2RnY3Fn" target="_blank" rel="noopener noreferrer">Instagram</a></b></p>
                </div>

                <div className='contactmap'>
                <img src={logo} alt="Logo" />  
                </div>
                
            </div>
            <br/>
            <br /> <br /> <br />
            <br /> 
        </div>
    )
}
